import {Model} from 'vue-mc';
import http from "../httpMiddleware/http";

Model.prototype.$http = http;
export default class bookingDetailModel extends Model {

    defaults() {
        return {
            service_date: '',
            service_date_formatted: '',
            job_type: '',
            client_name: '',
            ref_num: '',
            language: '',
            fm_interpreter_id: '',
            inter_trans: '',
            location_name: '',
            location_address_1: '',
            location_address_2: '',
            location_suburb: '',
            cancellation: '',
            location_postcode: '',
            start: '',
            end: '',
            requested_by: '',
            minLength: '',
            calds: ''
        }
    }

    options() {
        return {
            methods: {}
        }
    }

    routes() {
        return {}
    }


}
